import {buildTheme} from './configTheme'
import {buildRouter} from './configRouter'
import {buildProviders} from './configProviders'
import {buildStore} from './configStore'

export const build = app =>
  buildStore(buildProviders(buildTheme(buildRouter(app))))
